import { DataCellProps } from '../types';

export const TenantCsmCell = ({ _customRowProps, tenant }: DataCellProps) => {
  return <div>{tenant.csm}</div>;
};
